import axios from 'axios';
import AppConfig from '../config';
import { getDeviceInfo } from '../hooks/useDeviceInfo';
import { router } from '../index';
import store from '../store';
import { appSlice, authSlice } from '../store/slices';
import HelperService from './HelperService';

const { routes } = AppConfig;

const RequestService = {
	Token: null,
	Headers: {
		headers: {
			'Content-Type': 'text/plain',
			Accept: 'application/json',
		},
	},
	ClearStorage: () => {
		store.dispatch(authSlice.actions.resetState());
		store.dispatch(appSlice.actions.resetState());
	},
	OnNetworkError: error => {
		HelperService.showNotification({
			type: 'error',
			title: error.message || 'Network Error',
			autoHideDuration: 5000,
		});
		return error;
	},
	Logout: () => {
		RequestService.ClearStorage();
		router.navigate(routes.main);
	},
	Login: (
		Login,
		Password,
		InitData,
		deviceInfo,
		resultHandler,
		failHandler
	) => {
		return RequestService.RegulareRequest(
			'Auth/Login',
			{
				Login,
				Password,
				Device: {
					Name: deviceInfo.deviceModel || deviceInfo.osName,
					Uuid: deviceInfo.fingerprintId,
					Location: '',
					Type: deviceInfo.deviceType === 'mobile' ? 1 : 2,
					PushSubscription: null,
				},
				InitData,
			},
			false,
			{
				captchaPageHeader: 'Sign in',
				resultHandler,
				failHandler,
			}
		);
	},
	LoginByPinCode: (Login, PinCode, DeviceUuid, resultHandler, failHandler) => {
		const isInTelegram = store.getState().app.isItTelegram;
		const InitData = store.getState().app.initDataTG;
		console.log('RR: RR:RR:RR: ', isInTelegram);

		return RequestService.RegulareRequest(
			'Auth/LoginByPinCode',
			{
				Login,
				PinCode,
				InitData: isInTelegram ? InitData : null,
				DeviceUuid: isInTelegram ? null : DeviceUuid,
			},
			false,
			{
				captchaPageHeader: 'Sign in',
				resultHandler,
				failHandler,
			}
		);
	},
	CreateDevice: (token, deviceInfo) => {
		return RequestService.RegulareRequest('Device/Create', {
			Token: token,
			Device: {
				Name: deviceInfo.deviceModel || deviceInfo.osName,
				Uuid: deviceInfo.fingerprintId,
				Location: '',
				Type: deviceInfo.deviceType === 'mobile' ? 1 : 2,
				PushSubscription: null,
			},
		});
	},
	BaseThenFunc: (response, handleError = true) => {
		const errorCode = response?.data?.ErrorCode;

		if (errorCode === 'TokenInvalidError') {
			const token = sessionStorage.getItem('token');
			sessionStorage.removeItem('token');
			RequestService.Logout();
			if (token && token !== 'null') {
				console.log('Session is finished');
			}
		}

		if (
			handleError &&
			(response?.data?.Status === 'Error' || response?.Status === 'Error')
		) {
			const error = response?.data || response || {};
			const errorMessage = JSON.stringify(
				error.ErrorMessage ||
					error.ErrorCode ||
					error.Error?.Message ||
					error.Error?.Code ||
					error.message ||
					error.Error ||
					error
			);
			HelperService.showNotification({
				type: 'error',
				title: errorMessage,
				// autoHideDuration: 10000,
			});
		}

		return response.data;
	},
	BaseErrorFunc: (error, handleError = true) => {
		if (axios.isCancel(error)) return;

		if (handleError) {
			if (!error?.response) {
				RequestService.OnNetworkError(error);
			} else {
				const errorMessage = JSON.stringify(
					error.response.data?.title ||
						error?.response?.statusText ||
						error?.message ||
						error
				);
				HelperService.showNotification({
					type: 'error',
					title: errorMessage,
					autoHideDuration: 10000,
				});
			}
		}

		return error;
	},
	CapthcaHandler: (endpoint, data, handleError, requestProps) => {
		const captchaConfirmRequestData = {
			endpoint,
			data,
			handleError,
			...requestProps,
		};
		store.dispatch(
			appSlice.actions.setCaptchaConfirmRequestData(captchaConfirmRequestData)
		);
		router.navigate(
			{ pathname: routes.confirmCaptcha },
			{ state: { captchaPageHeader: requestProps?.captchaPageHeader } }
		);
	},
	RegulareRequest: async (
		endpoint = '',
		data = {},
		handleError = true,
		requestProps
	) => {
		const {
			token: Token,
			externalId: ExternalId,
			publicConfig,
		} = store.getState().app;

		const isFormData = data instanceof FormData;

		let body;
		let config;

		if (isFormData) {
			data.append('Token', Token);
			data.append('ExternalId', ExternalId);

			body = data;

			config = {
				headers: {
					Accept: 'application/json',
				},
			};
		} else {
			body = { ...data, Token, ExternalId };

			config = RequestService.Headers;
		}

		return await axios
			.post(publicConfig.apiUrl + endpoint, body, config)
			.then(response => {
				if (response.data.ErrorCode === 'AuthFromBlockedCountryError') {
					router.navigate(routes.accessRestricted);
					return;
				}

				const needConfirmCaptcha =
					response.data.ErrorCode === 'CaptchaValidationError';
				const thisRequestIsCaptchaValidating =
					data.captchaId && data.captchaCode;

				if (needConfirmCaptcha) {
					if (!thisRequestIsCaptchaValidating) {
						RequestService.CapthcaHandler(
							endpoint,
							{ ...data, Token, ExternalId },
							handleError,
							requestProps
						);
						return;
					}
					return response.data;
				}

				return RequestService.BaseThenFunc(response, handleError);
			})
			.catch(error => {
				return RequestService.BaseErrorFunc(error, handleError);
			});
	},
	StartRegistration: async (Login, resultHandler, failHandler) => {
		return RequestService.RegulareRequest(
			'Auth/StartRegistration',
			{ Login },
			false,
			{
				captchaPageHeader: 'Sign up',
				resultHandler,
				failHandler,
			}
		);
	},
	FinishRegistration: (
		Login,
		Password,
		PinCode,
		Device,
		resultHandler,
		failHandler
	) => {
		return RequestService.RegulareRequest(
			'Auth/FinishRegistration',
			{ Login, Password, PinCode, Device },
			undefined,
			{
				captchaPageHeader: 'Sign up',
				resultHandler,
				failHandler,
			}
		);
	},
	ResetPinCode: (Login, Password, InitData, DeviceUuid) => {
		const isInTelegram = store.getState().app.isItTelegram;
		return RequestService.RegulareRequest('Auth/ResetPinCode', {
			Login,
			Password,
			DeviceUuid: isInTelegram ? null : DeviceUuid,
			InitData: isInTelegram ? InitData : null,
		});
	},
	SetNewPinCode: (Login, Password, PinCode, DeviceUuid, InitData) => {
		const isInTelegram = store.getState().app.isItTelegram;
		return RequestService.RegulareRequest('Auth/SetNewPinCode', {
			Login,
			Password,
			PinCode,
			DeviceUuid: isInTelegram ? null : DeviceUuid,
			InitData: isInTelegram ? InitData : null,
		});
	},
	GetAllDevice: () => {
		return RequestService.RegulareRequest('Device/All');
	},
	DeleteDevice: DeviceIds => {
		return RequestService.RegulareRequest('Device/Delete', { DeviceIds });
	},
	GetAvailableCurrencies: () => {
		return RequestService.RegulareRequest('Currency/GetAvailableCurrencies');
	},

	GetWithdrawalBlockSettings: () => {
		return RequestService.RegulareRequest(
			'Settings/GetWithdrawalBlockSettings'
		);
	},

	GetBlockchains: () => {
		return RequestService.RegulareRequest('Blockchain/GetBlockchains');
	},
	GetCurrencies: () => {
		return RequestService.RegulareRequest('Currency/GetCurrencies');
	},
	GetQuotes: () => {
		return RequestService.RegulareRequest('Quote/GetQuotes');
	},
	GetAddressesByCurrency: CurrencyId => {
		return RequestService.RegulareRequest('Address/GetAddressesByCurrency', {
			CurrencyId,
		});
	},
	CreateAddress: ({ Currency, Label, Token }) => {
		return RequestService.RegulareRequest('Address/Create', {
			Currency,
			Label,
			Token,
		});
	},
	GetTransationByCurrency: (
		CurrencyId,
		AddressId,
		Page,
		Count,
		FromDate,
		ToDate,
		Search,
		Sort,
		Filters,
		Filter
	) => {
		return RequestService.RegulareRequest(
			'Transaction/GetTransactionListByCurrency',
			{
				CurrencyId,
				AddressId,
				Page,
				FromDate,
				ToDate,
				Count,
				Search,
				SortField: Sort?.by,
				SortDirection: Sort?.desc ? 'DESC' : 'ASC',
				Filters,
				Filter,
			}
		);
	},
	GetTransationByCard: async (
		CardId,
		Page,
		Count,
		FromDate,
		ToDate,
		Search,
		Sort,
		Filters,
		Filter
	) => {
		const res = {
			Transactions: [
				{
					Id: 200873,
					CurrencyId: 5,
					AddressId: 316524,
					AddressLabel: 'erc2',
					Comment: '',
					Amount: -5,
					AmountUsd: -5,
					Created: '2026-02-03T14:00:52.274461Z',
					IsDeposit: false,
					TransactionType: 9,
					TransactuinStatus: 3,
				},
				{
					Id: 200869,
					CurrencyId: 5,
					AddressId: 316521,
					AddressLabel: 'qwerty qwerty ',
					Comment: '',
					Amount: -5,
					AmountUsd: -5,
					Created: '2026-02-03T13:55:12.803468Z',
					IsDeposit: false,
					TransactionType: 9,
					TransactuinStatus: 3,
				},
				{
					Id: 200243,
					CurrencyId: 4,
					AddressId: 316522,
					AddressLabel:
						'qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty qwerty ',
					Comment: '',
					Amount: -0.000323056310503528,
					AmountUsd: -0.000323056310503528,
					Created: '2026-01-15T09:47:20.493029Z',
					IsDeposit: false,
					TransactionType: 8,
					TransactuinStatus: 2,
				},
			],
			Total: 148,
			Offset: 0,
			Status: 'Success',
			ErrorCode: null,
			ErrorMessage: null,
			Error: null,
		};
		return await new Promise(resolve => setTimeout(() => resolve(res), 1000));

		return RequestService.RegulareRequest(
			'Transaction/GetTransactionListByCard',
			{
				CardId,
				Page,
				FromDate,
				ToDate,
				Count,
				Search,
				SortField: Sort?.by,
				SortDirection: Sort?.desc ? 'DESC' : 'ASC',
				Filters,
				Filter,
			}
		);
	},
	GetTransationsByCurrencyId: CurrencyId => {
		return RequestService.RegulareRequest(
			'Transaction/GetTransactionListByCurrency',
			{ CurrencyId }
		);
	},
	WithdrawalPrepare: (
		SourceAddress,
		DestinationAddress,
		CryptoCurrency,
		Amount,
		Comment,
		CommissionType,
		Commission,
		FileIds
	) => {
		return RequestService.RegulareRequest('Withdrawal/Prepare', {
			SourceAddress,
			DestinationAddress,
			CryptoCurrency,
			Amount,
			Comment,
			CommissionType,
			Commission,
			FileIds,
		});
	},
	WithdrawalConfirm: async data => {
		const isInTelegram = store.getState().app.isItTelegram;
		const InitData = store.getState().app.initDataTG;
		const { fingerprintId: DeviceUuid } = await getDeviceInfo();

		data = {
			...data,
			InitData: isInTelegram ? InitData : null,
			DeviceUuid: isInTelegram ? null : DeviceUuid,
			Uuid: isInTelegram ? null : DeviceUuid,
		};
		return RequestService.RegulareRequest('Withdrawal/Confirm', data, false);
	},

	BillingGetBalanceHistory: data => {
		return RequestService.RegulareRequest('Billing/GetBalanceHistory', data);
	},

	WithdrawalCancelPrepare: WithdrawalPreparedIds => {
		return RequestService.RegulareRequest('Withdrawal/CancelPrepare', {
			WithdrawalPreparedIds,
		});
	},
	GetTransactionDetail: transactionId => {
		return RequestService.RegulareRequest('Transaction/GetTransactionDetail', {
			Id: transactionId,
		});
	},
	GetTronCommission: (acount, recipient, asset, amount) => {
		return RequestService.RegulareRequest('Transaction/GetTronCommission', {
			SourceAddress: acount,
			DestinationAddress: recipient,
			CryptoCurrency: asset,
			Amount: amount,
		});
	},
	GetBillingBalance: () => {
		return RequestService.RegulareRequest('Billing/GetBalance');
	},
	AddBillingBalance: async data => {
		const isInTelegram = store.getState().app.isItTelegram;
		const InitData = store.getState().app.initDataTG;
		const { fingerprintId: DeviceUuid } = await getDeviceInfo();

		data = {
			...data,
			InitData: isInTelegram ? InitData : null,
			DeviceUuid: isInTelegram ? null : DeviceUuid,
			Uuid: isInTelegram ? null : DeviceUuid,
		};
		return RequestService.RegulareRequest('Billing/AddBalance', data, false);
	},
	GetBillingTariffList: () => {
		return RequestService.RegulareRequest('Billing/GetTariffPaymentsList');
	},
	GetAddressGSBalance: AddressId => {
		return RequestService.RegulareRequest('GasStation/GetGasStations', {
			AddressId,
		});
	},
	CalculateCommission: (
		SourceAddresses,
		DestinationAddress,
		CurrencyId,
		Amount
	) => {
		return RequestService.RegulareRequest(
			'Transaction/CalculateCurrencyCommission',
			{
				SourceAddresses,
				DestinationAddress,
				CurrencyId,
				Amount,
			}
		);
	},

	GetAmlSettings: () => {
		return RequestService.RegulareRequest('AddressAml/GetAmlSettings', {});
	},
	GetAmlServicePrice: () => {
		return RequestService.RegulareRequest('Billing/GetAmlServicePrice', {});
	},
	CheckAmlAddress: (Address, Blockchain) => {
		return RequestService.RegulareRequest(
			'AddressAml/Check',
			{
				Address,
				Blockchain,
			},
			false
		);
	},
	AmlHistory: ({
		Page,
		Count,
		SortField,
		SortDirection,
		Search,
		Filters,
		FromDate,
		ToDate,
	} = {}) => {
		return RequestService.RegulareRequest('AddressAml/History', {
			Page,
			Count,
			SortField,
			SortDirection,
			Search,
			Filters,
			FromDate,
			ToDate,
		});
	},
	GetAddressAmlDetailsByAddress: Address => {
		return RequestService.RegulareRequest(
			'AddressAml/AddressAmlDetailsByAddress',
			{
				Address,
			}
		);
	},
	GetAddressAmlDetailsById: Id => {
		return RequestService.RegulareRequest('AddressAml/AddressAmlDetailsById', {
			Id,
		});
	},

	GetActiveTopUpsList: async () => {
		return RequestService.RegulareRequest('Billing/GetActiveTopUpsList');
	},
	CreateCaptcha: async () => {
		return RequestService.RegulareRequest('Auth/GetCaptcha');
	},
	GetUserCurrentPermissions: async () => {
		return RequestService.RegulareRequest('User/GetCurrentPermissions');
	},
	GetMinFeeForDefaultMethod: async () => {
		return RequestService.RegulareRequest('User/GetCurrentPermissions');
	},
	GetPushSubscriptionKey: async () => {
		return RequestService.RegulareRequest('Device/GetPubKey');
	},
	PushSubscribe: async subscribeData => {
		return RequestService.RegulareRequest(
			'Device/PushSubscribe',
			subscribeData
		);
	},
	GetCardData: async data => {
		return await new Promise(resolve =>
			setTimeout(
				() =>
					resolve({
						Status: 'Success',
						Data: {
							Number: '1234567812345678',
							Expiration: '01/28',
							Cvv: '482',
						},
					}),
				500
			)
		);
		return RequestService.RegulareRequest('Card/GetCardData', data);
	},
	GetCards: async data => {
		return await new Promise(resolve =>
			setTimeout(
				() =>
					resolve({
						Status: 'Success',
						Cards: getMockCards(),
					}),
				500
			)
		);
		return RequestService.RegulareRequest('Card/GetCards', data);
	},
	CloseCard: async data => {
		return await new Promise(resolve =>
			setTimeout(() => {
				closeMockCard(data);
				resolve(
					data.PinCode === '123456'
						? { Status: 'Success' }
						: {
								Status: 'Error',
								ErrorCode:
									data.PinCode === '000000'
										? 'TestError'
										: 'InvalidPinCodeError',
						  }
				);
			}, 500)
		);
		return RequestService.RegulareRequest('CloseCard/Close', data, false);
	},
	VerificationEmailPhone: async (emailCode, phoneCode) => {
		console.log('VerificationEmailPhone with params', emailCode, phoneCode);
		return await new Promise(resolve =>
			setTimeout(() => resolve({ Status: 'Success' }), 500)
		);
		return RequestService.RegulareRequest(
			'Verif/EmailPhone',
			{ EmailCode: emailCode, PhoneCode: phoneCode },
			false
		);
	},
	ResendVerificationCode: async (email, phone) => {
		console.log('ResendVerificationCode with params', email, phone);
		return await new Promise(resolve =>
			setTimeout(() => resolve({ Status: 'Success' }), 500)
		);
		return RequestService.RegulareRequest(
			'Verif/EmailPhone',
			{ Email: email, Phone: phone },
			false
		);
	},
	CreateCard: async (label, color, firstName, lastName, email, phone) => {
		console.log(
			'CreateCard with params',
			label,
			color,
			firstName,
			lastName,
			email,
			phone
		);
		return await new Promise(resolve =>
			setTimeout(
				() =>
					resolve({
						Status: 'Error',
						NeedVerify: true,
						NeedVerifyEmail: false,
						NeedVerifyPhone: true,
					}),
				1500
			)
		);
		return RequestService.RegulareRequest(
			'Card/CreateCard',
			{
				Label: label,
				Color: color,
				FirstName: firstName,
				LastName: lastName,
				Email: email,
				Phone: phone,
			},
			false
		);
	},
	GetCardHistory: async (CardId, Page, Count, Sort) => {
		console.log('GetCardHistory with params', CardId, Page, Count, Sort);
		const res = [
			{
				Id: 200879,
				CurrencyId: 5,
				AddressId: 317782,
				AddressLabel: 'qwqw',
				Comment: '',
				Amount: 100,
				AmountUsd: 100,
				Created: '2026-02-03T14:11:31.401703Z',
				IsDeposit: true,
				TransactionType: 1,
				TransactuinStatus: 2,
			},
			{
				Id: 200865,
				CurrencyId: 4,
				AddressId: 317783,
				AddressLabel: 'qwqw',
				Comment: '',
				Amount: 0.05855605,
				AmountUsd: 133.9733145975,
				Created: '2026-02-03T12:21:32.346133Z',
				IsDeposit: true,
				TransactionType: 1,
				TransactuinStatus: 2,
			},
			{
				Id: 166500,
				CurrencyId: 2,
				AddressId: 25529,
				AddressLabel: '',
				Comment: '',
				Amount: 1,
				AmountUsd: 0.3339,
				Created: '2025-09-26T11:27:05.838535Z',
				IsDeposit: true,
				TransactionType: 1,
				TransactuinStatus: 2,
			},
			{
				Id: 166498,
				CurrencyId: 3,
				AddressId: 25508,
				AddressLabel: '',
				Comment: '',
				Amount: -13.5182575892,
				AmountUsd: -13.5182575892,
				Created: '2025-09-26T11:21:29.474369Z',
				IsDeposit: false,
				TransactionType: 2,
				TransactuinStatus: 3,
			},
			{
				Id: 156270,
				CurrencyId: 2,
				AddressId: 25520,
				AddressLabel: '',
				Comment: '',
				Amount: 1,
				AmountUsd: 0.343728,
				Created: '2025-09-15T19:24:12.22671Z',
				IsDeposit: true,
				TransactionType: 1,
				TransactuinStatus: 2,
			},
			{
				Id: 156269,
				CurrencyId: 2,
				AddressId: 25520,
				AddressLabel: '',
				Comment: '',
				Amount: -0.339,
				AmountUsd: -0.339,
				Created: '2025-09-15T19:24:12.202977Z',
				IsDeposit: false,
				TransactionType: 8,
				TransactuinStatus: 2,
			},
			{
				Id: 156268,
				CurrencyId: 3,
				AddressId: 25508,
				AddressLabel: '',
				Comment: '',
				Amount: 21,
				AmountUsd: 21,
				Created: '2025-09-15T19:24:12.178769Z',
				IsDeposit: true,
				TransactionType: 1,
				TransactuinStatus: 2,
			},
			{
				Id: 156266,
				CurrencyId: 2,
				AddressId: 25520,
				AddressLabel: '',
				Comment: '',
				Amount: 1,
				AmountUsd: 0.343723,
				Created: '2025-09-15T19:23:12.223855Z',
				IsDeposit: true,
				TransactionType: 1,
				TransactuinStatus: 2,
			},
			{
				Id: 156265,
				CurrencyId: 2,
				AddressId: 25520,
				AddressLabel: '',
				Comment: '',
				Amount: -0.339,
				AmountUsd: -0.339,
				Created: '2025-09-15T19:23:12.201522Z',
				IsDeposit: false,
				TransactionType: 8,
				TransactuinStatus: 2,
			},
			{
				Id: 156263,
				CurrencyId: 3,
				AddressId: 25503,
				AddressLabel: '',
				Comment: '',
				Amount: -14.089615,
				AmountUsd: -14.089615,
				Created: '2025-09-15T19:22:36.640357Z',
				IsDeposit: false,
				TransactionType: 2,
				TransactuinStatus: 2,
			},
		];
		return await new Promise(resolve =>
			setTimeout(() => resolve({ Status: 'Error', Transactions: res }), 1500)
		);
		return RequestService.RegulareRequest('Card/GetCardTransactions', {
			CardId,
			Page,
			Count,
			SortField: Sort?.by,
			SortDirection: Sort?.desc ? 'DESC' : 'ASC',
		});
	},
	UploadFile: async file => {
		const formData = new FormData();
		formData.append('File', file);

		return RequestService.RegulareRequest('File/Upload', formData);
	},
	FileDownload: async ({ Id }) => {
		const { token: Token } = store.getState().app;

		return await axios
			.post(
				AppConfig.apiUrl + 'File/Download',
				{
					Id: Id,
					Token: Token,
				},
				{
					...RequestService.Headers,
					responseType: 'blob',
				}
			)
			.then(RequestService.BaseThenFunc)
			.catch(RequestService.BaseErrorFunc);
	},
};

/** todo: remove when backand ready */
let MockCards = [
	{
		Id: 1,
		Color: 'black',
		Number: '1234567812345678',
		CardholderName: 'Alexandr Wike',
		PaymentSystem: 'mastercard',
		Status: 'active',
		Label: 'Personal',
		BalanceUsd: 870.333333333,
		Addresses: [
			{
				CurrencyId: 3,
				BlockchainId: 2,
				AddressId: 62107,
				AddressLabel: '',
				Amount: 37.910384372,
				AmountUsd: 37.910384372,
				Address: 'TDpnbY2ndAvgKwacLPWbHV8kppVDgsqhV2',
			},
			{
				CurrencyId: 5,
				BlockchainId: 3,
				AddressId: 25566,
				AddressLabel: '',
				Amount: 0,
				AmountUsd: 0,
				Address: '0x9a2feb7cc12273999e87cbc2fc6f709eecda3abc',
			},
			{
				CurrencyId: 12,
				BlockchainId: 6,
				AddressId: 71307,
				AddressLabel: 'sdsd',
				Amount: 0,
				AmountUsd: 0,
				Address: '0xd58c013b1201b3614ecafc8f347f7aa9f58291f9',
			},
		],
	},
	{
		Id: 2,
		Color: 'green',
		Number: '2234567812345678',
		CardholderName: 'Alexandr Wike',
		PaymentSystem: 'visa',
		Status: 'frozen',
		Label: 'Corporative',
		BalanceUsd: 1922.3999999999,
	},
	{
		Id: 3,
		Color: 'blue',
		Number: '4234567812345678',
		CardholderName: 'Alexandr Wike',
		PaymentSystem: 'mastercard',
		Status: 'active',
		Label: 'Personal',
		BalanceUsd: 70.04,
	},
	{
		Id: 4,
		Color: 'purple',
		Number: '2234567812345678',
		CardholderName: 'Alexandr Wike',
		PaymentSystem: 'visa',
		Status: 'frozen',
		Label: 'Card',
		BalanceUsd: 70.04,
	},
	{
		Id: 5,
		Color: 'white',
		Number: '4234567812345678',
		CardholderName: 'Alexandr Wike',
		PaymentSystem: 'mastercard',
		Status: 'active',
		Label: 'Personal',
		BalanceUsd: 70.04,
	},
	{
		Id: 6,
		Color: 'green',
		Number: '2234567812345678',
		CardholderName: 'Alexandr Wike',
		PaymentSystem: 'visa',
		Status: 'frozen',
		Label: 'Personal',
		BalanceUsd: 70.04,
	},
];

function getMockCards() {
	return MockCards;
}
function closeMockCard({ Id }) {
	MockCards = MockCards.map(card =>
		card.Id === Id ? { ...card, Status: 'closed' } : card
	);
}

export default RequestService;
